import { Box } from "@mui/material";
import HeathenPfp from "../assets/backgroundImages/heathenPfp.svg";
import { createPortal } from "react-dom";

const flag =
  new Date().getMonth() === 5
    ? ["#cd1027", "#ff8c00", "#ffed00", "#008026", "#004dff", "#750787"]
    : ["#cd1027", "#fefffe", "#010101"];

const Background = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        maxHeight: "100%",
        justifyContent: "fixed",
        position: "absolute",
        zIndex: -1,
        "& > *": { flexGrow: 1 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bottom: "0",
          height: "100%",
          width: "100vw",
          background: `url(${HeathenPfp})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom left",
          backgroundSize: "contain",
        }}
      />
      {flag.map((color) => (
        <Box sx={{ backgroundColor: color }} key={color} />
      ))}
    </Box>
  );
};

const BackgroundWrapper = () => {
  return createPortal(<Background />, document.getElementById("background"))
}

export default BackgroundWrapper;
